import React from 'react';
import LiveStreamBroadcaster from '../../components/streaming/LiveStreamBroadcaster';

export default function LiveStream() {
  return <LiveStreamBroadcaster />;
}
